(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

  $(function(){
    if (/Mobi/.test(navigator.userAgent)) {
      $("body").addClass("mobile-device")
    }
  });

  (function(){

    function toggleSearch(isClose) {
      if(isClose) {
        $(".show-mobile-search-form > i").removeClass("icon-accordian-collapsed").addClass('icon-search-ico');
        $(".mobile-search-form").hide();
      } else {
        $(".show-mobile-search-form > i").toggleClass("icon-search-ico icon-accordian-collapsed");
        $(".mobile-search-form").fadeToggle();
      }
    }
    <!-- Show mobile search form -->
    $(".show-mobile-search-form").on("click", this, function (e) {
      toggleSearch();
      if($("body").hasClass("hamburger-expanded"))
        $(".mobile-navtoggle").click() // hide hamburger menu if user clicks search
    });

    $("#Search").on("focus", this, function(){
      $(this).addClass("transition-width");
    }).on("blur", this, function(){
      $(this).removeClass("transition-width");
    });

    if(slate.utils.isTouchDevice()) {
      $('body').click(function(event){
        if ($(event.target).closest('.navigation').length) {
          return; //do nothing if event target is within the navigation
        } else {
          $('.site-nav--has-submenu').removeClass("nav-open");
        }
      });
      $('.site-nav--has-submenu > a').click(function(e) {
        if(e) e.preventDefault();
        $(this).parent().addClass('nav-open');
      })
    }

    $(".mobile-navtoggle").on("click", function (e) {
      $("html, body").toggleClass("hamburger-expanded");
      if($(".mobile-search-form").is(":visible"))
        toggleSearch(true); // hide search if user clicks hamburger
    });
    <!--
    $(".mobile-device .site-nav .site-nav--has-submenu > a").on("click", this, function(e){
      e.preventDefault();
      console.log("sub nav open/close");
      $(".mobile-device .site-nav .site-nav--has-submenu .site-nav__submenu").fadeToggle();
    });

    $(".mobile-navtoggle").on("click", this, function (e) {
      $(this).toggleClass("nav-open");
      $(".header-navigation nav").toggleClass("nav-open");
    });

    $("[data-toggle]").click(function (e) {
        if (e) e.preventDefault();
        $("[data-block-id='"+$(this).data("toggle")+"']").toggleClass("show");
    });
    -->
  })();


  } catch(e) { console.error(e); }
})();
})();
